import type { AssessmentStatus, DesignationTrafficLight } from '@/lib/api/assessment';

export type AssessmentResultTone = 'green' | 'yellow' | 'red' | 'unknown';

export function assessmentResultTone(
  status: AssessmentStatus,
  light: DesignationTrafficLight,
): AssessmentResultTone {
  if (status === 'unlikely' || light === 'red') {
    return 'red';
  }
  if (status === 'conditional' || light === 'yellow') {
    return 'yellow';
  }
  if (status === 'available' || light === 'green') {
    return 'green';
  }
  return 'unknown';
}

export function assessmentStatusTitle(
  status: AssessmentStatus,
  labels: Record<AssessmentStatus, string>,
): string {
  switch (status) {
    case 'available':
      return labels.available;
    case 'conditional':
      return labels.conditional;
    case 'unlikely':
      return labels.unlikely;
    case 'unknown':
    default:
      return labels.unknown;
  }
}
